import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateColor } from '../../api/COLORS/colors';
import { toast } from 'react-toastify';

export const useUpdateColor = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ colorId, colorData }) => updateColor(colorId, colorData),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['colors'] });
            toast.success('Couleur modifiée avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la modification de la couleur');
        },
    });
};
